export * from "./prismic-gql/category";
export * from "./prismic-gql/market";
export * from "./prismic-gql/service";
